import React, {useState} from "react";
import Card from "../../../components/card";
import InputForm from "../../../components/input-form";
import SelectComponent from "../../../components/select-component";
import {MaskDefault} from "../../../utils/mask";
import InputDateTime from "../../../components/input-datetime";
import InputCheckbox from "../../../components/input-checkbox";
import GeneralUtils from "../../../utils/general";

    const genderOptions = [
        {value: "Masculino", label: "Masculino"},
        {value: "Feminino", label: "Feminino"},
    ];

    const calculateAge = (birthDate) => {
        if (!birthDate) return "";

        const today = new Date();
        const date = new Date(birthDate);
        if (Number.isNaN(date.getTime()) || date > today) return "";

        let age = today.getFullYear() - date.getFullYear();
        const hasNotHadBirthday = today.getMonth() < date.getMonth()
            || (today.getMonth() === date.getMonth() && today.getDate() < date.getDate());

        if (hasNotHadBirthday) age -= 1;

        return age;
    };

    const PersonalSection = ({state, handleInput, handleSelect, handleDateInput, handleCheckBox, disabled}) => {
        const [cpfValidate, setCpfValidate] = useState(null)
        const handleBirthDateChange = (value) => {
            handleDateInput(value, "birth_date");
            handleInput({target: {id: "age", value: calculateAge(value)}});
        };

        const validateCpf = (e) => {
            const {value} = e.target;
            const cpf = GeneralUtils.validateCpf(value);
            setCpfValidate(cpf);
        }

    return (
        <Card title="Dados pessoais">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-4">
            <InputForm id="name" name="name" label="Nome *" col="col-span-4"
                       value={state.name} onChange={handleInput} disabled={disabled}/>
            <SelectComponent instanceId="gender" name="gender" label="Gênero" isCreatable
                             options={genderOptions} value={state.gender}
                             onChange={(value) => handleSelect("gender", value)}
                             formatCreateLabel={(inputValue) => `${inputValue}`}
                             col="col-span-2" isDisabled={disabled}/>
            <InputForm id="rg" name="rg" label="RG" type="text" col="col-span-2"
                       value={state.rg} onChange={handleInput} disabled={disabled}/>
            <div className={"relative lg:col-span-2"}>
                {
                    cpfValidate === false &&
                    <span className={"text-red-600 absolute top-[-19px] right-0"}>CPF inválido</span>
                }
                <InputForm onBlur={validateCpf} id="cpf" name="cpf" label="CPF"
                           value={state.cpf} onChange={handleInput} mask={MaskDefault.cpf}
                           disabled={disabled}/>
            </div>
            <InputForm id="cin" name="cin" label="CIN" col="col-span-2"
                       value={state.cin ?? ""} onChange={handleInput} mask={MaskDefault.cpf} disabled={disabled}/>


            <InputDateTime id="birth_date" label="Data de nascimento"
                           selected={state.birth_date}
                           onChange={handleBirthDateChange}
                           col="col-span-3" disabled={disabled}/>
            <InputForm id="age" name="age" label="Idade" col="col-span-3"
                       value={state.age} onChange={handleInput} disabled={disabled}/>
            <InputForm id="mother_name" name="mother_name" label="Nome da mãe"
                       col="col-span-3" value={state.mother_name} onChange={handleInput} disabled={disabled}/>
            <InputForm id="city" name="city" label="Cidade" col="col-span-3"
                       value={state.city} onChange={handleInput} disabled={disabled}/>

            <InputForm id="email" name="email" label="E-mail" col="col-span-3"
                       value={state.email} onChange={handleInput} disabled={disabled}/>
            <InputForm id="phone" name="phone" label="Telefone" col="col-span-3"
                       value={state.phone} onChange={handleInput} mask={MaskDefault.phone} disabled={disabled}/>
            <InputForm id="formation" name="formation" label="Formação" col="col-span-3"
                       value={state.formation} onChange={handleInput} disabled={disabled}/>
            <div className="flex gap-4 col-span-3">
                <InputCheckbox id="cnh" label="CNH" col="w-[120px]"
                               onChange={handleCheckBox} checked={state.cnh} disabled={disabled}/>
                <InputForm id="cnh_category" name="cnh_category" label="Categoria (CNH)"
                           col="w-full" value={state.cnh_category} onChange={handleInput} disabled={disabled}/>
            </div>
            </div>
        </Card>
    );
};

export default PersonalSection;
